import { HostServiceData } from 'types/host/host';
import {
  HostCpuTelemetryServiceData,
  HostHddTelemetryServiceData,
  HostMemoryTelemetryServiceData,
  HostNetworkTelemetryServiceData,
  HostUtilizationAggregateTelemetryServiceData,
  TrafficUsageServiceData,
} from 'types/host/telemetry/hostTelemetry';
import { DataAction, ErrorAction, FetchAction, PendingAction } from 'types/services/redux-action';
import { FetchReducer } from 'types/services/redux-state';

export const FETCH_HOST_STATUS = 'FETCH_HOST_STATUS';

export const FETCH_HOST_STATUS_IS_PENDING = 'FETCH_HOST_STATUS_IS_PENDING';

export const FETCH_HOST_STATUS_IS_ERROR = 'FETCH_HOST_STATUS_IS_ERROR';

export const FETCH_HOST_MEMORY_AGGREGATE = 'FETCH_HOST_MEMORY_AGGREGATE';

export const FETCH_HOST_MEMORY_AGGREGATE_IS_PENDING = 'FETCH_HOST_MEMORY_AGGREGATE_IS_PENDING';

export const FETCH_HOST_MEMORY_AGGREGATE_IS_ERROR = 'FETCH_HOST_MEMORY_AGGREGATE_IS_ERROR';

export const FETCH_HOST_CPU_AGGREGATE = 'FETCH_HOST_CPU_AGGREGATE';

export const FETCH_HOST_CPU_AGGREGATE_IS_PENDING = 'FETCH_HOST_CPU_AGGREGATE_IS_PENDING';

export const FETCH_HOST_CPU_AGGREGATE_IS_ERROR = 'FETCH_HOST_CPU_AGGREGATE_IS_ERROR';

export const FETCH_HOST_DISK_AGGREGATE = 'FETCH_HOST_DISK_AGGREGATE';

export const FETCH_HOST_DISK_AGGREGATE_IS_PENDING = 'FETCH_HOST_DISK_AGGREGATE_IS_PENDING';

export const FETCH_HOST_DISK_AGGREGATE_IS_ERROR = 'FETCH_HOST_DISK_AGGREGATE_IS_ERROR';

export const FETCH_HOST_NETWORK_AGGREGATE = 'FETCH_HOST_NETWORK_AGGREGATE';

export const FETCH_HOST_NETWORK_AGGREGATE_IS_PENDING = 'FETCH_HOST_NETWORK_AGGREGATE_IS_PENDING';

export const FETCH_HOST_NETWORK_AGGREGATE_IS_ERROR = 'FETCH_HOST_NETWORK_AGGREGATE_IS_ERROR';

export const FETCH_COLO_NETWORK_AGGREGATE = 'FETCH_COLO_NETWORK_AGGREGATE';

export const FETCH_COLO_NETWORK_AGGREGATE_IS_PENDING = 'FETCH_COLO_NETWORK_AGGREGATE_IS_PENDING';

export const FETCH_COLO_NETWORK_AGGREGATE_IS_ERROR = 'FETCH_COLO_NETWORK_AGGREGATE_IS_ERROR';

export const FETCH_HOST_NETWORK_UPLINK = 'FETCH_HOST_NETWORK_UPLINK';

export const FETCH_HOST_NETWORK_UPLINK_IS_PENDING = 'FETCH_HOST_NETWORK_UPLINK_IS_PENDING';

export const FETCH_HOST_NETWORK_UPLINK_IS_ERROR = 'FETCH_HOST_NETWORK_UPLINK_IS_ERROR';

export const FETCH_HOST_CURRENT = 'FETCH_HOST_CURRENT';

export const FETCH_HOST_CURRENT_IS_PENDING = 'FETCH_HOST_CURRENT_IS_PENDING';

export const FETCH_HOST_CURRENT_IS_ERROR = 'FETCH_HOST_CURRENT_IS_ERROR';

export const FETCH_HOST_STATUS_HISTORY = 'FETCH_HOST_STATUS_HISTORY';

export const FETCH_HOST_STATUS_HISTORY_IS_PENDING = 'FETCH_STATUS_HISTORY_IS_PENDING';

export const FETCH_HOST_STATUS_HISTORY_IS_ERROR = 'FETCH_STATUS_HISTORY_IS_ERROR';

export const FETCH_HARDWARE_CAPACITY_CURRENT = 'FETCH_HARDWARE_CAPACITY_CURRENT';

export const FETCH_HARDWARE_CAPACITY_CURRENT_IS_PENDING = 'FETCH_HARDWARE_CAPACITY_CURRENT_IS_PENDING';

export const FETCH_HARDWARE_CAPACITY_CURRENT_IS_ERROR = 'FETCH_HARDWARE_CAPACITY_CURRENT_IS_ERROR';

export const FETCH_HOST_HARDWARE_USAGE_HISTORY = 'FETCH_HOST_HARDWARE_USAGE_HISTORY';

export const FETCH_HOST_HARDWARE_USAGE_HISTORY_IS_PENDING = 'FETCH_HOST_HARDWARE_USAGE_HISTORY_IS_PENDING';

export const FETCH_HOST_HARDWARE_USAGE_HISTORY_IS_ERROR = 'FETCH_HOST_HARDWARE_USAGE_HISTORY_IS_ERROR';

export const FETCH_OVERUSE = 'FETCH_OVERUSE';

export const FETCH_OVERUSE_IS_PENDING = 'FETCH_OVERUSE_IS_PENDING';

export const FETCH_OVERUSE_IS_ERROR = 'FETCH_OVERUSE_IS_ERROR';

export const RESET_REDUCER = 'RESET_HOST_TELEMETRY';

export type HostReducerState = {
  hostStatusAggregate?: HostUtilizationAggregateTelemetryServiceData;
  fetchHostStatusIsCompleted: boolean;
  fetchHostStatusIsPending: boolean;
  fetchHostStatusIsError: null | unknown;
  hostMemoryAggregate: {} | HostMemoryTelemetryServiceData[];
  fetchHostMemoryAggregateIsCompleted: boolean;
  fetchHostMemoryAggregateIsPending: boolean;
  fetchHostMemoryAggregateIsError: null | unknown;
  hostCPUAggregate: {} | HostCpuTelemetryServiceData[];
  fetchHostCPUAggregateIsCompleted: boolean;
  fetchHostCPUAggregateIsPending: boolean;
  fetchHostCPUAggregateIsError: null | unknown;
  hostDiskAggregate: {} | HostHddTelemetryServiceData[];
  fetchHostDiskAggregateIsCompleted: boolean;
  fetchHostDiskAggregateIsPending: boolean;
  fetchHostDiskAggregateIsError: null | unknown;
  hostNetworkAggregate: {} | HostNetworkTelemetryServiceData[];
  fetchHostNetworkAggregateIsCompleted: boolean;
  fetchHostNetworkAggregateIsPending: boolean;
  fetchHostNetworkAggregateIsError: null | unknown;
  upLinks: {} | TrafficUsageServiceData[];
  fetchHostNetworkUplinkIsCompleted: boolean;
  fetchHostNetworkUplinkIsPending: boolean;
  fetchHostNetworkUplinkIsError: null | unknown;
  hosts: undefined | HostServiceData[];
} & FetchReducer<'fetch'>;

export type HostActions =
  | FetchAction<'FETCH_HOST_STATUS', HostUtilizationAggregateTelemetryServiceData[]>
  | FetchAction<'FETCH_HOST_MEMORY_AGGREGATE', HostMemoryTelemetryServiceData[]>
  | FetchAction<'FETCH_HOST_CPU_AGGREGATE', HostCpuTelemetryServiceData[]>
  | FetchAction<'FETCH_HOST_DISK_AGGREGATE', HostHddTelemetryServiceData[]>
  | FetchAction<'FETCH_HOST_NETWORK_AGGREGATE', HostNetworkTelemetryServiceData[]>
  | (DataAction<'FETCH_HOST_NETWORK_UPLINK', TrafficUsageServiceData[]> & { uplinkId: string | number })
  | ErrorAction<`FETCH_HOST_NETWORK_UPLINK_IS_ERROR`>
  | PendingAction<`FETCH_HOST_NETWORK_UPLINK_IS_PENDING`>
  | { type: 'RESET_HOST_TELEMETRY' };
